import { useI18n } from '../../i18n/i18n.jsx';
import Container from './Container';
import Section from './Section';
import SectionTitle from './SectionTitle';

const TestimonialCard = ({ testimonial, index, t }) => {
  return (
    <div
      className="group relative p-6 md:p-8 bg-white dark:bg-neutral-800 rounded-2xl border border-neutral-200 dark:border-neutral-700 hover:border-accent dark:hover:border-accent/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 animate-fade-in-up"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      {/* Quote Icon */}
      <div className="absolute top-4 right-4 text-6xl md:text-7xl text-accent/10 dark:text-accent/5 font-serif group-hover:text-accent/20 dark:group-hover:text-accent/10 transition-colors duration-300">
        "
      </div>

      {/* Stars Rating */}
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className="w-5 h-5 text-accent fill-current"
            viewBox="0 0 20 20"
          >
            <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
          </svg>
        ))}
      </div>

      {/* Testimonial Text */}
      <p className="text-base md:text-lg text-neutral-700 dark:text-neutral-200 leading-relaxed mb-6 relative z-10 italic">
        {t(`testimonials.items.${testimonial.key}.text`)}
      </p>

      {/* Author Info */}
      <div className="flex items-center gap-4 pt-4 border-t border-neutral-200 dark:border-neutral-700">
        <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-br from-accent to-primary flex items-center justify-center text-white font-bold text-lg md:text-xl shadow-lg group-hover:scale-110 transition-transform duration-300">
          {t(`testimonials.items.${testimonial.key}.name`).charAt(0)}
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-primary dark:text-white text-sm md:text-base">
            {t(`testimonials.items.${testimonial.key}.name`)}
          </h4>
          <p className="text-xs md:text-sm text-neutral-500 dark:text-neutral-400">
            {t(`testimonials.items.${testimonial.key}.role`)}
          </p>
        </div>
      </div>

      {/* Decorative corner */}
      <div className="absolute bottom-0 left-0 w-20 h-20 bg-gradient-to-tr from-accent/5 to-transparent rounded-tr-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </div>
  );
};

const Testimonials = () => {
  const { t } = useI18n();

  const testimonials = [
    {
      key: 'testimonial1'
    },
    {
      key: 'testimonial2'
    },
    {
      key: 'testimonial3'
    }
  ];

  return (
    <Section className="bg-neutral-light dark:bg-neutral-900/50">
      <Container>
        <SectionTitle
          title={t('testimonials.title')}
          subtitle={t('testimonials.subtitle')}
        />
        
        <div className="mt-8 md:mt-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard
                key={testimonial.key}
                testimonial={testimonial}
                index={index}
                t={t}
              />
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Testimonials;
